import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { NTAKProgramMainCategory, NTAKProgramSubCategory } from '../../models/serializable/ntak-program-settings.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class NTAKEventSettingsComponent extends Component {
  static readonly TYPE_ID = '19065ea6c63144d7a82e0684f3e52ea4';

  private constructor(
    public readonly mainCategory: NTAKProgramMainCategory,
    public readonly subCategory: NTAKProgramSubCategory,
    public readonly serviceLocationId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return NTAKEventSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static create(args: {
    mainCategory: NTAKProgramMainCategory,
    subCategory: NTAKProgramSubCategory,
    serviceLocationId: string,
  }): NTAKEventSettingsComponent {
    return new NTAKEventSettingsComponent(
        args.mainCategory,
        args.subCategory,
        args.serviceLocationId,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): NTAKEventSettingsComponent {
    return new NTAKEventSettingsComponent(
        toEnumFromString(MapUtils.getString(map, 'mainCategory'), NTAKProgramMainCategory),
        toEnumFromString(MapUtils.getString(map, 'subCategory'), NTAKProgramSubCategory),
        MapUtils.getString(map, 'serviceLocationId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'mainCategory': fromEnumAsString(this.mainCategory),
      'subCategory': fromEnumAsString(this.subCategory),
      'serviceLocationId': this.serviceLocationId,
    };
  }

  clone(): this {
    return this.copyWith() as this;
  }

  copyWith({
    mainCategory = this.mainCategory,
    subCategory = this.subCategory,
    serviceLocationId = this.serviceLocationId,
  }: {
    mainCategory?: NTAKProgramMainCategory,
    subCategory?: NTAKProgramSubCategory,
    serviceLocationId?: string,
  } = {}): this {
    return NTAKEventSettingsComponent.create({
      mainCategory,
      subCategory,
      serviceLocationId,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.mainCategory === this.mainCategory &&
        other.subCategory === this.subCategory &&
        other.serviceLocationId === this.serviceLocationId;
  }
}

export class NTAKEventSettingsComponentBuilder extends DataModelBuilder<NTAKEventSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): NTAKEventSettingsComponent {
    return NTAKEventSettingsComponent.fromMap(context, map);
  }
}
